import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLegend } from "../../slices/map";
export const useResetLegend = () => {
    const dispatch = useDispatch();
    useEffect(() => () => {
        dispatch(setLegend(null));
    }, []);
};
